module.exports = __webpack_public_path__ + "img/87.67a6b041.jpg";